/** The entry a firm approves for every Copilot Studio connector; never an agent's own client id. */
export const COPILOT_STUDIO_CLIENT_ID = 'copilot-studio';

export type AgentStatus = 'none' | 'approved' | 'withdrawn' | 'requested';

export interface AgentAccessAgent {
  clientId: string;
  name: string;
  /** Scheme and host. Only a verified agent's is established by LeanLaw; an unverified one chose its own. */
  origin: string;
  isVerifiedPublisher: boolean;
  /** Every destination an unverified self-registered agent can send an approval to. Null otherwise. */
  redirectUris: string[] | null;
  status: AgentStatus;
  /** Null means the whole catalogue, up to what the agent itself may ask for. */
  allowedScopes: string[] | null;
  approvedBy: string | null;
  approvedAtUtc: string | null;
  withdrawnBy: string | null;
  withdrawnAtUtc: string | null;
  activeConnectionCount: number;
  /** When someone last tried to connect this agent and was refused for want of approval. */
  requestedAtUtc: string | null;
  requestedBy: string | null;
}

export interface AgentAccessConnection {
  id: string;
  accountId: string;
  userName: string;
  userEmail: string;
  clientId: string;
  agentName: string;
  /** What the person approved, verbatim. A historical fact — never rewritten by a later policy change. */
  grantedScopes: string[];
  /** What it can reach now: granted, narrowed by the firm's current cap. */
  effectiveScopes: string[];
  consentedAtUtc: string;
  lastUsedAtUtc: string | null;
}

export interface AgentAccessPermission {
  /** The FRD id, e.g. P-01. */
  id: string;
  scope: string;
  label: string;
  description: string;
  isWrite: boolean;
  /**
   * Never implied by a wildcard or by a firm approval with no cap: it has to be named, by the firm and by
   * the person. Sending email is the case — it leaves LeanLaw and cannot be recalled.
   */
  requiresExplicitGrant: boolean;
}
